import { useEffect, useState } from "react";
import useVideoContext from "../useVideoContext/useVideoContext";
import { ConnectionState, RoomEvent } from "livekit-client";

export default function useRoomState() {
  const { room } = useVideoContext();
  const [state, setState] = useState(ConnectionState.Disconnected);
  useEffect(() => {
    const setRoomState = () => setState(room.state || ConnectionState.Disconnected);
    setRoomState();
    room.on(RoomEvent.ConnectionStateChanged, setRoomState);
    return () => {
      room.off(RoomEvent.ConnectionStateChanged, setRoomState);
    };
  }, [room]);
  return state;
}
